module.exports = __webpack_public_path__ + "annualreview2017/static/img/incentive-revenue@2x.93c4c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transparency/incentive-revenue@2x.png
// module id = 159
// module chunks = 0